// extracted by mini-css-extract-plugin
export default {"btn-entry":"MgMMMjX4J0bQDHyArb35","common_bganimation":"gZv72Denzmc8aJfQVRll"};